import * as j from '@mojotech/json-type-validation';

export const GetIsPendingRoutingProfileChangeDecoder: j.Decoder<boolean> = j
  .object({
    is_pending: j.boolean(),
  })
  .map((item) => item.is_pending);
